export const enDefineIcps = {
	findPeopleByJobTitles: "Find people by job titles",
	presets: {
		title: "Search profile presets",
		subtitle: "Load a saved waterfall, or configure below and save as a new preset.",
		update: "Update current preset",
		saveAsNew: "Save as new preset",
		clear: "Clear",
		namePlaceholder: "Preset name",
		save: "Save",
		cancel: "Cancel",
		empty: "No saved presets yet — configure below and save one.",
	},
	findMorePeople: {
		title: "Find more/different people at {{count}} selected companies",
		subtitle:
			"For 1–2 companies, use the Lead Panel. This bulk flow is best for running the same search across many companies at once.",
		submit: "Find more/different people at {{count}} companies",
	},
	upTo3searches: `You can trigger up to 3 searches with different combinations of job title and personal location.`,
	upTo3searchesInfo: `We are searching in the below order, based on how many people you want to get. If you
							want to identify 1 person and we have found one with the first search, the agent
							stops. If not, we will look for the second search. If you want to identify 2 or 3
							people and we have found one person with the first search, the agent will proceed with
							the second and third search.`,
	firstSearch: "First search profile",
	firstSearchInfo: `We’ll search for these job titles first`,
	secondSearch: "Second search profile",
	secondSearchInfo: `If no person was found or you want to find more than one person, we’ll search for the following job titles`,
	thirdSearch: "Third search profile",
	thirdSearchInfo: `If no person was found in previous searches or you want to find more than two people, we’ll search for the following job titles`,
	peoplePerCompany: "People per company",
	peoplePerCompanySubtitle: "How many contacts do you want to find at each company?",
	creditUsageLabel: "Credit usage:",
	creditUsageDescription:
		"{{credits}} credit per company processed (regardless of whether a person is found). Each additional person found beyond the first costs 1 more credit.",
	creditUsageExample:
		"Example: Finding 2 people at one company = 2 credits. Finding 0 or 1 = 1 credit.",
	howManyPeopleDoYouWantToFindPerCompany: "How many people do you want to find per company?",
	specifyTheNumberOfPeopleYouWantToFindPerCompany: `Specify the number of people you want to find per company. You’ll be charged 1 credit for every person found with a minimum of 1 credit. You can search for 1-3 people per company.`,
	specifyTheNumberOfPeopleYouWantToFindPerCompanyInfo: `At least one credit will be charged for every company where we start the person search also if we were not able to identify a person.`,
	defineIcp: {
		positionOrJobTitle: `Position or job title`,
		engineDatabaseAi: `Database + AI`,
		engineDatabaseAiInfo: `We search the mentioned job titles first across multiple lead databases. If nothing is found, we run AI searches across the web to find similar or non-indexed titles. Slower, but surfaces people with ambiguous titles who have relevant keywords in their LinkedIn headline or About section.`,
		engineDatabase: `Database`,
		engineDatabaseInfo: `We search multiple databases for people categorized at this department and seniority. Faster, and finds people who don’t have the exact job title — but limited to leads indexed in the databases.`,
		advisoryStartNarrow: `Start narrow, then broaden`,
		advisoryStartNarrowInfo: `Start with a narrow search, then broaden. Make the first search profile your most precise search so the best-fit person is found first, then use the second and third profiles as wider fallbacks.`,
		ceoAndSimilar: `CEO, Managing Director, Founder, Owner & Board Members`,
		ceoAndSimilarInfo: `We have optimized the AI agent to include all relevant job titles in other
												languages or gender-specific titles (e.g. Chief Executive Officer, MD,
												Geschäftsführer, Geschäftsführerin)`,
		searchForADifferentPositionOrJobTitle: `Search for a different position or job title`,
		onlySearchForDecisionMakersHeadOfAndHigher: `Only search for Decision-Makers (Head of and higher)`,
		usePersonaSegment: `Use persona category`,
		selectPersonaCategory: `Select a persona category`,
		exampleJobTitles: `Example job titles`,
		searchForSimilarJobTitles: `Search for similar job titles`,
		searchForSimilarJobTitlesInfo: `We’ll show you a list of similar job titles that get added as instructions for the AI agent. The AI agent is not searching for exact job titles. Please de-select irrelevant job titles. There is no limit how many job titles you can select or de-select. If the recommendations don’t fit, please try a different job title.`,
		personalLocation: `Personal location`,
		personalLocationInfo: `We’ll search for people in the following countries`,
		clear: "Clear",
		countrySelection: {
			HQ: `Search for people in the country of the company headquarter`,
			CUSTOM: `Only search for people in the following country or region`,
			ANY: `Anywhere`,
		},
		departmentAndSeniority: `Search by department and seniority`,
		seniorityLabel: "Seniority",
		seniorityPlaceholder: "e.g. C-Suite, VP, Director, etc.",
		departmentLabel: "Department",
		departmentPlaceholder: "e.g. Sales, Marketing, Engineering, etc.",
		regionsLabel: "Regions",
		regionsPlaceholder: "e.g. Europe, North America, etc.",
		countriesLabel: "Countries",
		countriesPlaceholder: "e.g. Germany, USA, etc.",
	},
	// PREC-4788: the list editor's own scraper searches every profile in the people database
	// first and broadens with AI afterwards, unlike the bulk/tracker find person (per profile).
	overrideRulesInfoText:
		"If no rule matches, or if the rule-based search doesn't find a person, the system tries your Search Profiles 1 → 2 → 3 as configured above, searching them in the people database in order and then broadening the search with AI.",
	bulkFindPeople: {
		title_one: "Find people at {{count}} selected company",
		title_other: "Find people at {{count}} selected companies",
		titlePlanning: "Find people at the selected companies",
		subtitle: "Pre-filled with this list's search profiles. Changes here apply to this run only.",
		subtitleNoListProfiles:
			"This list has no search profiles yet: add one below, or pick a saved preset. Changes here apply to this run only.",
		listProfiles: "This list's profiles",
		// PREC-3899: the run's "Use my contacts first" / "Find new people only".
		contactModeHint: "Applies to this run only. The list keeps its own setting.",
		profilesTitle: "Search profiles",
		profilesHint: "· searched in this order, each in the people database and then with AI",
		notSet: "not set",
		add: "Add",
		edit: "Edit",
		done: "Done",
		noPosition: "No position chosen yet",
		needsInput: "Needs input: {{problem}}",
		problem: {
			noPosition: "no position or job title",
			noTitle: "no job title",
			noPersona: "no persona category",
			noDepartmentOrSeniority: "no department or seniority",
			noPlace: "no country or region",
		},
		ruleProblem: {
			noPosition: "Override rule {{rule}} has no action. Choose one, or remove the rule.",
			noTitle: "Override rule {{rule}} has no job title. Add one, or remove the rule.",
			noPersona: "Override rule {{rule}} has no persona category. Choose one, or remove the rule.",
			noDepartmentOrSeniority:
				"Override rule {{rule}} has no department or seniority. Choose one, or remove the rule.",
			noPlace: "Override rule {{rule}} has no country. Name one, or search anywhere.",
		},
		planChanged:
			"The selection changed since you checked it. Here is the new plan; review it and start again.",
		persona: "Persona category: {{name}}",
		personaUnknown: "Persona category",
		departmentSeniority: "Department and seniority: {{value}}",
		location: "Personal location: {{place}}",
		locationAny: "Anywhere",
		locationHq: "In the country of the company headquarter",
		fewer: "Fewer",
		more: "More",
		forPeopleFound: "For the people found (as set in List Settings)",
		changeInListSettings: "Change in List Settings",
		lookupLabel: {
			email: "Email:",
			phone: "Phone:",
			companyContact: "Company email & phone:",
		},
		lookupText: {
			emailOnAdd_one: "looked up when the person is added · {{count}} credit per email found",
			emailOnAdd_other: "looked up when the person is added · {{count}} credits per email found",
			phoneOnAdd_one: "looked up when the person is added · {{count}} credit per lookup",
			phoneOnAdd_other: "looked up when the person is added · {{count}} credits per lookup",
			companyContactOnAdd_one:
				"looked up when a person is added and their company has neither yet · {{count}} credit per lookup",
			companyContactOnAdd_other:
				"looked up when a person is added and their company has neither yet · {{count}} credits per lookup",
			companyContactWhenNoEmail_one:
				"looked up when a person is added without a valid email · {{count}} credit per lookup",
			companyContactWhenNoEmail_other:
				"looked up when a person is added without a valid email · {{count}} credits per lookup",
			onAssign: "looked up later, when the lead is assigned to a campaign",
			onSend: "looked up later, when an email to the lead is about to be sent",
			off: "not looked up",
		},
		placementLeads:
			"The people found are added to this list as leads: the first one in place of the company's “Person not found” row, the others as rows of their own. This list's campaign rules and AI columns apply to them, as to any lead it adds.",
		placementTracker:
			"The first person found is selected on the company's row, and only they are looked up as above. The others are tracked at the company: like every tracked person, they get this tracker's signal checks, and nothing is looked up for them.",
		companies_one: "{{count}} company",
		companies_other: "{{count}} companies",
		upToPeopleEach_one: "up to {{count}} person each",
		upToPeopleEach_other: "up to {{count}} people each",
		upToPeople_one: "up to {{count}} person found",
		upToPeople_other: "up to {{count}} people found",
		costFindPerson: "Find person · {{companies}}, {{people}}",
		costLookup: {
			email: "Email lookup · {{people}}",
			phone: "Phone lookup · {{people}}",
			companyContact: "Company email & phone lookup · {{lookups}}",
			aiColumns: "AI columns · {{runs}}",
		},
		upToLookups_one: "up to {{count}} lookup",
		upToLookups_other: "up to {{count}} lookups",
		upToColumnRuns_one: "up to {{count}} column run",
		upToColumnRuns_other: "up to {{count}} column runs",
		total: "Total",
		creditRange: "{{min}} – {{max}} credits",
		credits_one: "{{count}} credit",
		credits_other: "{{count}} credits",
		priceNote:
			"{{credits}} credit per company searched, whether or not someone is found; each additional person costs {{credits}} more. Your balance: {{balance}} credits.",
		balanceTooLow:
			"Your balance of {{balance}} credits does not cover the {{min}} credits this search costs at least. Add credits, or select fewer companies.",
		planning: "Checking the selected rows…",
		planError: "We could not check the selected rows, so the search cannot start.",
		listError: "This list's search settings could not be loaded, so the search cannot start.",
		tryAgain: "Try again",
		noCompanies: "None of the selected rows can be searched.",
		leftOut_one: "{{count}} selected row is left out:",
		leftOut_other: "{{count}} selected rows are left out:",
		ignoredRows_one: "{{count}} row of this view already has a person and is not searched.",
		ignoredRows_other: "{{count}} rows of this view already have a person and are not searched.",
		skippedReason: "{{reason}} ({{count}})",
		noProfile: "Add at least one search profile, or pick a saved preset.",
		incompleteProfile: "Finish the search profile marked “Needs input”, or clear it.",
		submit_one: "Find people at {{count}} company",
		submit_other: "Find people at {{count}} companies",
		submitPlanning: "Find people",
		submitError: "The search could not be started.",
		resultTitle: "Searching for people",
		resultQueued_one:
			"Searching for people at {{count}} company. Its row updates when it has been searched, usually within a few minutes.",
		resultQueued_other:
			"Searching for people at {{count}} companies. Each row updates when its company has been searched, usually within a few minutes per company.",
		resultNone: "No company was searched.",
		skipped_one: "{{count}} selected row was skipped:",
		skipped_other: "{{count}} selected rows were skipped:",
		close: "Done",
		startedInBackground_one:
			"Find people started at {{count}} company; {{skipped}} selected rows skipped.",
		startedInBackground_other:
			"Find people started at {{count}} companies; {{skipped}} selected rows skipped.",
		startFailed: "Find people could not be started.",
		enrichMenuSubtitle:
			"{{credits}} credit per company searched, +{{credits}} per additional person",
	},
	trackerFindPerson: {
		stepTitle: "Find a person when a signal names no one you know",
		stepDescription:
			"Optional. When a P1–P3 signal arrives for a company where this tracker knows nobody, we can look for one person there and put them on the lead row.",
		switchLabel: "When a signal has no known person, find one automatically",
		switchHelp:
			'When a P1–P3 signal arrives for a company where this tracker knows nobody, we look for one person there with the search profiles below. The person found replaces the "Select prospect" row and is added to the company\'s tracked people. Found people are tracked like any other person in this tracker, including their signal checks, and are handled like any lead added to this list: contact details are looked up and campaign rules apply. Further people found at the company, for example by Find person with more than one person per company, are tracked there, and nothing is looked up for them.',
		price: "{{credits}} credit per company searched, whether or not someone is found",
		// PREC-4570: the lookups the person placed on the row gets, as the list's settings ask
		priceLookupIntro: "For the person placed on the lead row, as set in List Settings:",
		priceLookup: {
			email_one: "+ {{count}} credit per email found",
			email_other: "+ {{count}} credits per email found",
			phone_one: "+ {{count}} credit per phone lookup",
			phone_other: "+ {{count}} credits per phone lookup",
			companyContact_one: "+ {{count}} credit per company email & phone lookup",
			companyContact_other: "+ {{count}} credits per company email & phone lookup",
		},
		offHelp:
			'With the switch off, nothing is searched or charged, and signals for companies where you know nobody land as "Select prospect" rows.',
		fixed:
			"People per company: 1 (fixed for trackers). Presets and override rules work as in the Find person step of company lists.",
		needsProfile: "Add at least one search profile, or switch the automatic search off.",
		noSource: "This list's search settings could not be found, so the switch was not saved.",
		row: {
			searching: "Searching for a person…",
			searchingSince: "Started {{time}} · usually a few minutes",
			foundAutomatically: "found automatically",
			notFoundSince:
				"Searched {{date}} · searched again with a new signal after {{days}} days, or when the search profiles change",
			noCredits:
				"Not searched automatically on {{date}}: your credits or plan do not cover a search. The next signal tries again.",
			off: "Find person is off for this list",
		},
	},
};
